"use client";

import Link from 'next/link';
import Image from 'next/image';
import { useLocale, useTranslations } from 'next-intl';

export default function InternalLinks({ relatedCards }) {
  const t = useTranslations('tarot.card');
  const locale = useLocale();

  if (!relatedCards || relatedCards.length === 0) {
    return null;
  }

  return (
    <div className="my-20">
      <h3 className="text-2xl font-serif text-[#FBFBFE] mb-4 pb-3 mx-auto max-w-md text-center">
       {t('related')}
      </h3>
      <div className="flex flex-wrap gap-6 justify-center mt-6">
        {relatedCards.map((card) => (
          <Link key={card.slug} href={`/${locale}/tarot-cards/${card.slug}`}>
            <div className="group block text-center cursor-pointer transform transition-transform duration-300 hover:scale-105">
              <div className="relative w-32 h-52 mx-auto mb-2 rounded-lg overflow-hidden border-2 border-[#6A3683]/50 group-hover:border-[#A45DE8] shadow-md group-hover:shadow-lg transition-all duration-300">
                <Image
                  src={card.imageUrl}
                  alt={card.name}
                  layout="fill"
                  objectFit="cover"
                  sizes="(max-width: 768px) 100vw, 33vw" // Add sizes prop for fill layout
                  className="transition-opacity duration-300 group-hover:opacity-80"
                />
              </div>
              <span className="text-[#FBFBFE] group-hover:text-[#D4B6FF] transition-colors duration-200 text-base font-marcellus font-semibold">
                {card.name}
              </span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
} 